module.exports = __webpack_public_path__ + "static/img/kl1350-663-370gld.e27b3ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/kl1350-663-370gld.jpg
// module id = WSZ8
// module chunks = 0